import { Map, View } from 'ol';
import { defaults as defaultInteractions } from 'ol/interaction';
import { OpenLayersMapHost } from './OpenLayersMapHost.js';
import { createPanelPlanningLayerStack } from './layerFactories/panelPlanningLayers.js';
import { mapCursorPlugin } from './plugins/mapCursorPlugin.js';
import {
  panelPerfAttachTileLayerWatch,
  panelPerfAttachMapRenderWatch
} from '../utils/panelPlanningPerfLog.js';

/**
 * 패널 플래닝용 MapHost 팩토리
 * @param {string} targetId — DOM target (예: 'map')
 * @param {object} [options]
 * @param {[number, number]} [options.center]
 * @param {number} [options.zoom]
 * @param {boolean} [options.attachCursorPlugin]
 * @param {'canvas'|'webgl'} [options.renderer] — 벡터 렌더러 선택
 * @param {object} [options.cursorContext] — mapCursorPlugin ctx
 */
export function createPanelPlanningMapHost(targetId, options = {}) {
  const {
    center = [126.978, 37.5665],
    zoom = 20,
    attachCursorPlugin = false,
    renderer = 'canvas',
    cursorContext = {}
  } = options;

  const stack = createPanelPlanningLayerStack({ renderer });
  const view = new View({
    center,
    zoom,
    projection: 'EPSG:4326',
    doubleClickZoom: false
  });

  const map = new Map({
    target: targetId,
    interactions: defaultInteractions({ doubleClickZoom: false }),
    layers: stack.layers,
    view
  });

  const host = new OpenLayersMapHost({
    map,
    view,
    targetId,
    vectorSource: stack.vectorSource,
    vectorLayer: stack.vectorLayer,
    namedLayers: {
      satellite: stack.satelliteTileLayer,
      siteImage: stack.siteImageTileLayer,
      vector: stack.vectorLayer
    }
  });

  if (attachCursorPlugin) {
    host.attachPlugin(mapCursorPlugin, {
      getTargetElement: () => document.getElementById(targetId),
      getVectorLayer: () => host.getVectorLayer(),
      ...cursorContext
    });
  }

  panelPerfAttachTileLayerWatch(stack.satelliteTileLayer, 'satellite-wms');
  panelPerfAttachTileLayerWatch(stack.siteImageTileLayer, 'site-image-wms');
  panelPerfAttachMapRenderWatch(map, 'panel-map');

  return host;
}

export { mapCursorPlugin };
